import {Button, ButtonGroup} from 'platform/components';
import {Text, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

interface SetToAllVehiclesDialogProps extends RequiredTestIdProps {
  description: string;
  isLoading: boolean;
  // Confirm applies the new watermark to the existing vehicles; cancel still creates it.
  onConfirm: VoidFunction;
  onCancel: VoidFunction;
}

export function SetToAllVehiclesDialog(props: SetToAllVehiclesDialogProps) {
  return (
    <VStack spacing={1}>
      <Text>{props.description}</Text>
      <ButtonGroup align="right">
        <Button
          variant="secondary"
          onClick={props.onCancel}
          isDisabled={props.isLoading}
          title={i18n.t('general.actions.cancel')}
          data-testid={suffixTestId('cancel', props)}
        />
        <Button
          variant="primary"
          onClick={props.onConfirm}
          isLoading={props.isLoading}
          title={i18n.t('general.actions.confirm')}
          data-testid={suffixTestId('confirm', props)}
        />
      </ButtonGroup>
    </VStack>
  );
}
